import React, { FC, useState } from 'react';
import s from './ErrorButton.scss';
import { useTranslation } from 'react-i18next';
import dataHooks from '../../../constants/data-hooks';
import { useErrorData } from '../../../../hooks/use-error-data';
import { useBiLogger } from '../../../../hooks/use-bi-logger';
import { reportError } from '../errorsMapping';
import classNames from 'classnames';
import { ArrowRight } from '@wix/wix-ui-icons-common';
import { BrandStyle } from '../../../constants';

interface ErrorButtonProps {
  link: string;
  label: string;
}

const ErrorButton: FC<ErrorButtonProps> = ({ link, label }) => {
  const { t } = useTranslation();
  const errorData = useErrorData();
  const biLogger = useBiLogger();
  const errorCode =
    (errorData?.errorCode.slice(0, 3) as BI_Events_Error_Key) || 'default';
  const [isWixelHovered, setIsWixelHovered] = useState(false);
  const isWixel = errorData?.brand === BrandStyle.wixel;
  const isBase44 = errorData?.brand === BrandStyle.base44;
  const isSymphony = errorData?.brand === BrandStyle.symphony;
  return (
    <a
      href={t(link)}
      data-hook={dataHooks.errorButton}
      onClick={() => reportError({ biLogger, biEventsErrorKey: errorCode })}
    >
      <button
        className={classNames(s.errorButton, {
          [s.wixelErrorButton]: isWixel,
          [s.base44ErrorButton]: isBase44,
          [s.symphonyErrorButton]: isSymphony,
          [s.defaultErrorButton]: !isWixel && !isBase44 && !isSymphony,
        })}
        onMouseEnter={() => isWixel && setIsWixelHovered(true)}
        onMouseLeave={() => isWixel && setIsWixelHovered(false)}
      >
        {t(label)}
        {isWixel && (
          <ArrowRight
            className={classNames(s.arrow, {
              [s.arrowHidden]: !isWixelHovered,
              [s.arrowDisplay]: isWixelHovered,
            })}
            size="2vw"
          />
        )}
      </button>
    </a>
  );
};
export default ErrorButton;
